import React, { useState, FormEvent, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EyeOutline,EyeOffOutline } from "heroicons-react";
import {toast} from "react-toastify";
import { AppDispatch } from '../../store/store';
import { registerUser } from '../../store/UserSlice';

export default function Register() {
  const navigate = useNavigate();
  
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [userPayload, setUserPayload] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: '',
    isAdmin: false, 
  });

  const [errors, setErrors] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const fullNameRef = useRef<HTMLInputElement | null>(null);
  const emailRef = useRef<HTMLInputElement | null>(null);

  const handleButtonClick = async (e: FormEvent) => {
    e.preventDefault();

    if (!/^[a-zA-Z\s]+$/.test(userPayload.fullName) && (userPayload.fullName)) {
         toast.error('Please enter only character');
         if (fullNameRef.current) {
          fullNameRef.current.focus();
        }
      return; // Stop further processing if validation fails
    }
  
    // Custom validation for the 'email' field
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
      if (!emailRegex.test(userPayload.email) && (userPayload.email)) {
        toast.error('Invalid email format');
        if (emailRef.current) {
          emailRef.current.focus();
        }
        return; // Stop further processing if validation fails
      }
    

    if ((userPayload.password !== userPayload.confirmPassword) && userPayload.confirmPassword) {
      setErrors({
        ...errors,
        confirmPassword: 'Passwords do not match',
      });
      return;
    }
    const { confirmPassword, ...userPayloadWithoutConfirmPassword } = userPayload;

    // Dispatch registration action
    try {
      const result = await dispatch(registerUser(userPayloadWithoutConfirmPassword));
      
      if (registerUser.fulfilled.match(result)) {
        const isSuccess = result.payload; // Assuming the payload is a boolean
  
        if (isSuccess) {
          toast.success('Registered successfully');
          navigate('/login');
        } 
      } 
    } catch (error: any) {
      toast.error(error.response?.data?.error?.message || 'Registration failed. Please try again.');
    }
  };
  
  const dispatch: AppDispatch = useDispatch();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
        
    setUserPayload({
      ...userPayload,
      [name]: value,
    });

    // Clear errors when user starts typing
    setErrors({
      ...errors,
      [name]: "",
    });

  

  };

  
  return (     
    
    <div className="flex flex-col lg:flex-row items-center">
      <div className="hidden lg:flex w-1/2">
      <img src='./images/loginpic.jpg' className='object-cover w-full h-screen' alt="sideimage"/>
      </div>
      <div className="w-full lg:w-1/2 p-8" >
      <form onSubmit={handleButtonClick}>
      <div className='max-w-2xl m-auto'>
    <div className='text-center'>
    <img src='./images/bluelogo.png' alt="Logo" className='mx-auto mb-6' /> 
    <h2 className='mb-2 font-gilroy text-[#263238] font-semibold text-[26px] md:text-[30px]'>Create your account</h2>
      <p className='text-gray-7 text-[#78909C] font-gilroy text-[18px]'>Lorem Ipsum is simply dummy text of the printing and typesetting.</p>
    </div>

     <div className='pt-4 lg:pt-8'>
      
       <label htmlFor='fullName' className='block pb-2 text-[#263238] font-[18px] font-gilroy-medium'>Full Name</label>
           <input   ref={fullNameRef}
 className='border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] py-3 px-4'  type="text" name="fullName" placeholder='Enter your full name' value={userPayload.fullName} id="fullName"
                 onChange={(e)=>handleChange(e)}/>
       {errors.email && <p className="text-red-500 text-sm">{errors.fullName}</p>}
     </div>

     <div className='pt-4 lg:pt-8'>
       <label htmlFor='email' className='block pb-2 text-[#263238] font-[18px] font-gilroy-medium'>Email Address</label>
       <input   ref={emailRef}
 className='border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] py-3 px-4'  type="text" name="email" placeholder='Enter your email' value={userPayload.email} id="email"
               onChange={(e)=>handleChange(e)} />  
       {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
     </div>


     <div className='pt-4 lg:pt-8 w-full relative'>
        <label htmlFor="password" className='block pb-2 text-[#263238] font-[18px] font-gilroy-medium'>Password</label>
        <input className='border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] py-3 px-4'  type={showPassword?"text":"password"} name="password"  value={userPayload.password} placeholder='Enter your password' minLength={8} id="password"  onChange={(e)=>handleChange(e)}/>

        <div className='absolute bottom-4 right-4 cursor-pointer' onClick={()=>setShowPassword(prev=>!prev)}>{showPassword?<EyeOffOutline color='#AAB7C2'/>:<EyeOutline color='#AAB7C2' />}</div>
        {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
     </div>

     <div className='pt-4 lg:pt-8 w-full relative'>
        <label htmlFor="confirmPassword" className='block pb-2 text-[#263238] font-[18px] font-gilroy-medium'>Confirm Password</label>
        <input
        className='border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] py-3 px-4'
            type={showConfirmPassword ? 'text' : 'password'}
            name="confirmPassword"
            value={userPayload.confirmPassword}
            placeholder='Confirm your password'
            id="confirmPassword"
            minLength={8}
            
            onChange={(e) => handleChange(e)}
            />

        <div className='absolute bottom-4 right-4 cursor-pointer' onClick={() => setShowConfirmPassword((prev) => !prev)}>
            {showConfirmPassword ? <EyeOffOutline color='#AAB7C2' /> : <EyeOutline color='#AAB7C2' />}
        </div>
        {errors.confirmPassword && (
            <p className="text-red-500 text-sm">{errors.confirmPassword}</p>
            )}
    </div>
    <button type='submit' className='bg-[#037897] w-full mt-10  py-4 text-white font-gilroy-bold uppercase rounded-[8px]'>Login</button>

    <h4 className='p-4 mt-4 text-center'>Already have an account? <a href='login' className='text-[#037897]'>Login</a></h4>
   </div>
   </form>
    </div>
  </div>
  );
}
